/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import ReportCard from 'shared/ui/components/analytics/ReportCard.vue';
import ReportListDisplay from 'shared/ui/components/analytics/ReportListDisplay.vue';

import { isFunction } from 'lodash';

const BLOCKS = [{
    name: 'engagements',
    iconStyle: 'alt-3',
    reports: [
        { name: 'badge-printing', icon: 'badge', showPlatforms: false, module: 'onsite-scanning', anonymizable: false, includeFpExtId: true },
        { name: 'live-sessions', icon: 'star', module: 'live-streams', anonymizable: true, showPaxFieldsFn: event => !(event.is_anonymized && !event.anonymization_domains) && !event.is_webinar },
        { name: 'feeds', icon: 'feed', showPlatforms: false, module: 'feed', anonymizable: false },
        { name: 'activity', icon: 'users', module: 'participants', anonymizable: false },
        { name: 'interactivity', icon: 'qna', showPlatforms: false, anonymizable: true },
        { name: 'attendance', icon: 'star', showPlatforms: false, anonymizable: false, featureFlag: 'attendance_tracking_enabled', hideDates: true, includeFpExtId: true },
        { name: 'meetings', icon: 'session', module: 'meetings', anonymizable: false, showPlatforms: false, showPaxFieldsFn: () => false }
    ]
}, {
    name: 'contents',
    iconStyle: 'alt-1',
    reports: [
        { name: 'pages', icon: 'file', module: 'content-pages', anonymizable: true },
        { name: 'documents', icon: 'file-text', module: 'documents', anonymizable: true },
        { name: 'forms', icon: 'list', module: 'pkg-forms', anonymizable: true },
        { name: 'leads', icon: 'lead', module: 'leads', anonymizable: false, showPlatforms: false },
        { name: 'sessions', icon: 'session', module: 'sessions', anonymizable: false },
        { name: 'speakers', icon: 'mic', module: 'presenter', anonymizable: true },
        { name: 'sponsors', icon: 'thumbs-up', module: 'sponsors', anonymizable: true },
        { name: 'videos', icon: 'film', module: 'video-library', anonymizable: true },
    ],
}];

const __vue_script__ = {
    name: 'ReportsList',

    components: { ReportCard, ReportListDisplay },

    props: {
        event: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            alertClass: '',
            alertText: '',
            alertTextDetails: undefined,
            blocks: [],
            showAlertDetails: false,
            eventIsFullyAnonymized: this.event.is_anonymized && !this.event.anonymization_domains,
        };
    },

    created() {
        this.blocks = BLOCKS.map(block => this.parseBlock(block));

        if (this.eventIsFullyAnonymized) {
            this.alertClass = 'alert-warning';
            this.alertText = this.$i18n.t('analytics.anonymization.anonymization_enabled');
        } else if (this.event.anonymization_domains?.length) {
            this.alertClass = 'alert-warning';
            this.alertText = this.$i18n.t('analytics.anonymization.anonymization_selected_users');
            this.alertTextDetails = this.$i18n.t('analytics.anonymization.anoynmization_domains');
        } else {
            const orgs = this.$services.user.getCurrentUser().orgs;
            for (const org of orgs) {
                if (org._id === this.event.ownerId && org.enable_anonymization) {
                    this.alertClass = 'alert-success';
                    this.alertText = this.$i18n.t('analytics.anonymization.anonymization_disabled');
                    break;
                }
            }
        }
    },

    methods: {
        parseBlock(block) {
            block.label = this.$t(`analytics.sections.${block.name}`);
            block.reports = block.reports
                .filter(report => this.showReport(report))
                .map(report => this.parseReport(report, block))
                .sort((a, b) => this.getReportLabel(a) > this.getReportLabel(b) ? 1 : -1);

            return block;
        },

        parseReport(report, block) {
            report.iconStyle = block.iconStyle;
            report.showPaxFields = isFunction(report.showPaxFieldsFn)
                ? report.showPaxFieldsFn(this.event)
                : !(report.anonymizable && this.eventIsFullyAnonymized);

            delete report.module;
            delete report.anonymizable;

            return report;
        },

        getReportLabel({ name }) {
            return this.$t(`analytics.reports.${name}.title`);
        },

        showReport(report) {
            const isBetaTester = this.$services.user.isBetaTester();

            if (report.betaTesterOnly && !isBetaTester) {
                return false;
            }

            if (report.featureFlag && !this.event[report.featureFlag]) {
                return false;
            }

            return !report.module || this.$services.blueprint.isModuleInstalled(report.module);
        },

        toggleAlertDetails() {
            this.showAlertDetails = !this.showAlertDetails;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('report-list-display',{attrs:{"blocks":_vm.blocks,"event":_vm.event}},[(_vm.alertText)?_c('div',{staticClass:"alert anonymized-alert",class:_vm.alertClass},[_c('h5',[(_vm.alertTextDetails)?_c('a',{staticClass:"has-action",attrs:{"role":"button"},on:{"click":_vm.toggleAlertDetails}},[(!_vm.showAlertDetails)?_c('span',[_vm._v(_vm._s(_vm.$t('general.show_more')))]):_vm._e(),(_vm.showAlertDetails)?_c('span',[_vm._v(_vm._s(_vm.$t('general.show_less')))]):_vm._e()]):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.alertText))])]),(_vm.showAlertDetails)?_c('p',[_vm._v(_vm._s(_vm.alertTextDetails))]):_vm._e(),(_vm.showAlertDetails && _vm.event.anonymization_domains.length)?_c('ul',_vm._l((_vm.event.anonymization_domains),function(domain){return _c('li',[_c('strong',[_vm._v(_vm._s(domain))])])}),0):_vm._e()]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ReportsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__